// 交易看板統計信息組件
export default {
  // 轉入部分
  transferIn: "轉入",
  earliestTransferIn: "最早轉入：",

  // 轉出部分
  transferOut: "轉出",
  latestTransferOut: "最近轉出：",

  // 統計標籤
  transactionCount: "交易次數",
  transactionAmount: "交易數量",
  counterparties: "交易對手",

  // 單位
  times: "次",
  tenThousand: "萬",
  units: "個",
};
